import type { QueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateBatteryPriceDependents } from "./battery-price-dependents"
import type { BatteryConcertApplicationStatusDto } from "../dto/battery-concert-application.dto"

/**
 * Every Concert application command returns the status read it just wrote.
 * Approval also moves the Quote, selected Loan Product, and payment, so the
 * financing and financial-summary reads are refetched alongside it.
 */
export const applyBatteryConcertApplicationStatus = (
  queryClient: QueryClient,
  proposalId: string,
  status: BatteryConcertApplicationStatusDto,
): void => {
  queryClient.setQueryData(
    queryKeys.batteryProposal.concertApplication(proposalId),
    status,
  )
  // A confirmed loan-document send is what starts the supplemental package, so
  // the section that shows it has to read again rather than keep a cached
  // "not sent" from before the click.
  void queryClient.invalidateQueries({
    queryKey: queryKeys.batteryProposal.concertSupplemental(proposalId),
  })
  invalidateBatteryPriceDependents(queryClient, proposalId)
}

/** A failed command may still have moved server state (failed / uncertain). */
export const invalidateBatteryConcertApplication = (
  queryClient: QueryClient,
  proposalId: string,
): void => {
  invalidateBatteryPriceDependents(queryClient, proposalId)
}
